/* Lightweight PostHog wrapper. No-op if REACT_APP_POSTHOG_KEY is not set. */
import posthog from "posthog-js";

const KEY = process.env.REACT_APP_POSTHOG_KEY;
const HOST = process.env.REACT_APP_POSTHOG_HOST || "https://app.posthog.com";

let initialized = false;

export function initAnalytics() {
  if (initialized) return;
  if (!KEY) {
    // eslint-disable-next-line no-console
    console.info("[PostHog] REACT_APP_POSTHOG_KEY not set — analytics disabled.");
    return;
  }
  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: true,
    persistence: "localStorage+cookie",
    autocapture: true,
    disable_session_recording: false,
    loaded: () => { initialized = true; },
  });
  initialized = true;
}

export function identify(user) {
  if (!KEY || !user?.user_id) return;
  try {
    posthog.identify(user.user_id, {
      email: user.email,
      name: user.name,
      is_guest: !!user.is_guest,
      creator_type: user.preferences?.creator_type,
      onboarded: !!user.preferences?.onboarded,
    });
  } catch { /* noop */ }
}

export function track(event, props = {}) {
  if (!KEY) return;
  try { posthog.capture(event, props); } catch { /* noop */ }
}

export function resetAnalytics() {
  if (!KEY) return;
  try { posthog.reset(); } catch { /* noop */ }
}

// Convenience event names — kept here so they stay consistent across the app.
export const EVENTS = {
  ONBOARDING_COMPLETED: "onboarding_completed",
  IDEA_CREATED: "idea_created",
  IDEA_STAGE_CHANGED: "idea_stage_changed",
  PIPELINE_VIEWED: "pipeline_viewed",
  AI_SCRIPT_GENERATED: "ai_script_generated",
  AI_COPILOT_OPENED: "ai_copilot_opened",
  DEMO_LOADED: "demo_workspace_loaded",
  GUEST_STARTED: "guest_demo_started",
  GUEST_TO_SIGNIN_CLICKED: "guest_to_signin_clicked",
  FEEDBACK_SUBMITTED: "feedback_submitted",
  SESSION_DURATION: "session_duration_logged",
};
